// globalFluentOverrides.ts
import { makeStyles } from "@fluentui/react-components";

export const useGlobalFluentOverrides = makeStyles({
  root: {
    "--link-color": "#0078d4",
    "& .fui-Select__select": {
      width: "100% !important",
      maxWidth: "100% !important",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  },
});
